function getDefaultValuesForForm({
  schema = [],
  getValueByControl = () => null,
}) {
  if (!Array.isArray(schema)) {
    return {};
  }

  let initialValues = {};
  schema.forEach(field => {
    const hasChildren = field.children && field.children.length > 0;
    if (hasChildren) {
      initialValues = {
        ...initialValues,
        ...getDefaultValuesForForm({
          schema: field.children,
          getValueByControl,
        }),
      };
    } else {
      const finalValue = getValueByControl({
        field,
      });
      initialValues[field.name] = finalValue;
    }
  });

  return initialValues;
}

export default getDefaultValuesForForm;
